import React from 'react'

import styles from './Claim.module.css'

const Claim = () => {
  return (
    <h3 className={styles.claim}>
      Jesus Christus, derselbe gestern und heute und in Ewigkeit.
    </h3>
  )
}

export default Claim



// WEBPACK FOOTER //
// ./src/components/header/Claim.js